//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/mixins/global";
import axios, { CancelToken } from "axios";
import Page03Sub01 from "../components/Page03Sub01";

export default {
  components: {
    Page03Sub01
  },

  data() {
    return {
      tab: "print",
      visible1: true,
      date: "",
      location: {
        value: "G1",
        label: "G1"
      },
      locations: [
        {
          value: "G1",
          label: "G1"
        },
        {
          value: "G2",
          label: "G2"
        },
        {
          value: "G3",
          label: "G3"
        },
        {
          value: "G4",
          label: "G4"
        },
        {
          value: "TRM",
          label: "TRM"
        },
        {
          value: "VN2",
          label: "VN2"
        }
      ],
      processData: [],
      eff: 0,
      defect: 0,
      target: 0,
      actual: 0
    };
  },
  created() {
    this.CheckLocal();
    this.LoadFirst();
  },
  async mounted() {},
  watch: {
    location: function(newValue, oldValue) {
      this.LoadData();
    },
    date: function(newValue, oldValue) {},
    tab: function(newValue, oldValue) {
      this.LoadData();
    }
  },
  methods: {
    LoadFirst() {
      this.pulling = setTimeout(() => {
        this.chkAuthen("", "");
        this.CurrDate();
        this.pullData();
        this.LoadData();
      }, 1000);
    },

    pullData() {
      this.pulling = setInterval(() => {
        var currentdate = new Date();
        if (
          currentdate.getMinutes() % 5 == 0 &&
          currentdate.getSeconds() == 0
        ) {
          this.LoadData();
        }
        // console.log(currentdate)
      }, 1000);
    },
    CurrDate() {
      let params = new FormData();
      axios({
        method: "post",
        url: this.$api + "Page03.php/curdate",
        data: params
      }).then(res => {
        this.date = res.data.dte;
      });
    },
    LoadData() {
      this.visible1 = false;
      this.processData = [];
      this.eff = 0;
      this.defect = 0;
      this.target = 0;
      this.actual = 0;

      if (this.tab == "print") {
        this.LoadDataPrint();
      } else if (this.tab == "emb") {
        this.LoadDataEmb();
      } else if (this.tab == "bonding") {
        this.LoadDataBond();
      } else if (this.tab == "padprint") {
        this.LoadDataPad();
      } else if (this.tab == "heat") {
        this.LoadDataHeat();
      }
    },
    LoadDataEmb() {
      let params = new FormData();
      params.append("loc", this.location.value);
      axios({
        method: "post",
        url: this.$api + "Page03.php/emb",
        data: params
      }).then(res => {
        // console.log(res.data);
        this.processData = res.data.data;
        this.eff = res.data.eff;
        this.defect = res.data.defect;
        this.target = res.data.target;
        this.actual = res.data.actual;
        this.visible1 = true;
      });
    },
    LoadDataPrint() {
      let params = new FormData();
      params.append("loc", this.location.value);
      axios({
        method: "post",
        url: this.$api + "Page03.php/print",
        data: params
      }).then(res => {
        // console.log(res.data);
        this.processData = res.data.data;
        this.eff = res.data.eff;
        this.defect = res.data.defect;
        this.target = res.data.target;
        this.actual = res.data.actual;
        this.visible1 = true;
      });
    },
    LoadDataBond() {
      let params = new FormData();
      params.append("loc", this.location.value);
      axios({
        method: "post",
        url: this.$api + "Page03.php/bond",
        data: params
      }).then(res => {
        // console.log(res.data)
        this.processData = res.data.data;
        this.eff = res.data.eff;
        this.defect = res.data.defect;
        this.target = res.data.target;
        this.actual = res.data.actual;
        this.visible1 = true;
      });
    },
    LoadDataPad() {
      let params = new FormData();
      params.append("loc", this.location.value);
      axios({
        method: "post",
        url: this.$api + "Page03.php/pad",
        data: params
      }).then(res => {
        // console.log(res.data)
        this.processData = res.data.data;
        this.eff = res.data.eff;
        this.defect = res.data.defect;
        this.target = res.data.target;
        this.actual = res.data.actual;
        this.visible1 = true;
      });
    },
    LoadDataHeat() {
      let params = new FormData();
      params.append("loc", this.location.value);
      axios({
        method: "post",
        url: this.$api + "Page03.php/heat",
        data: params
      }).then(res => {
        console.log(res.data);
        this.processData = res.data.data;
        this.eff = res.data.eff;
        this.defect = res.data.defect;
        this.target = res.data.target;
        this.actual = res.data.actual;
        this.visible1 = true;
      });
    },
    getClassSize() {
      if (this.$q.screen.width <= 1440) {
        return "text-h4 fnt";
      } else {
        return "text-h3 fnt";
      }
    }
  }
};
